import type { FunctionComponent } from 'react';
import { useSelector } from 'react-redux';

import * as IssuesV2Store from '../../../../redux/issuesV2';
import { FilterPanel } from '../../../generic/Filter';
import useFetchIssuesAction from '../../IssuesInbox/hooks/useFetchIssuesAction';
import FilterCardMultiSelect from '../../../generic/Filter/FilterCardMultiSelect';
import useCwes from '../../IssuesInbox/hooks/useCwes';
import type { SelectOption } from '../../../../types';
import { selectOptionFactory } from '../../../../utils';

/**
 * Add a multi-select dropdown menu for filtering issues by CWEs.
 */
const CweFilter: FunctionComponent = () => {
  const cweFilter = useSelector(IssuesV2Store.selectors.getCweFilter);
  const setCweFilter = useFetchIssuesAction(IssuesV2Store.actions.setCwesFilter);

  const { isLoading, cwes } = useCwes();

  const isDisabled = isLoading || cwes.length <= 1;
  const hasSingleCwe = cwes.length === 1;

  // convert CWEs between the MultiSelectFilterOption[] type (used in the redux store)
  // and the SelectOption[] type used by the multi-select component
  const formattedSelectedCwes: Array<SelectOption<string | number>> = cwes
    .filter((cwe) => cweFilter.includes(cwe.value))
    .map((cwe) => selectOptionFactory(cwe.value));
  const onChange = (selectedOptions: Array<SelectOption<string | number>>) => {
    if (selectedOptions.length) {
      setCweFilter(selectedOptions.map((option) => option.value));
    } else {
      setCweFilter([]);
    }
  };

  return (
    <FilterPanel>
      <FilterCardMultiSelect
        label="CWEs"
        placeholder={isLoading ? 'Loading...' : 'Select one or more...'}
        values={hasSingleCwe ? cwes : formattedSelectedCwes}
        options={cwes}
        isDisabled={isDisabled}
        testId="issues-cwe-filter"
        onChange={onChange}
      />
    </FilterPanel>
  );
};

export default CweFilter;
